import React from "react";
import {
  CssBaseline,
  Grid,
  ThemeProvider,
} from "@mui/material";
import setsterLogo from "./../images/setster-logo.png";
import useCustomTheme from "../hooks/useCustomTheme";
import Item from "./item";
import SetsterLogo from "./setsterLogo";
import ErrorComponent from "./error";

const Layout = ({ children, errors = [], itemsSx = null, contentGridSx = null }) => {
  const theme = useCustomTheme();

  itemsSx = itemsSx || { backgroundColor: "rgba(255,255,255)" };
  contentGridSx = contentGridSx || {
    padding: theme.spacing(10),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(10, 5),
    },
  };
  return (
    <ThemeProvider theme={theme}>
      <Grid
        container
        direction="row"
        component="main"
        sx={{
          backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 1500"><rect fill="%23081634" width="2000" height="1500"/><defs><rect stroke="%23081634" stroke-width="0.1" width="1" height="1" id="s" rx=".3"/><pattern id="a" width="3" height="3" patternUnits="userSpaceOnUse" patternTransform="scale(20.3) translate(-950.74 -713.05)"><use fill="%23081634" href="%23s" y="2"/><use fill="%23081634" href="%23s" x="1" y="2"/><use fill="%23081634" href="%23s" x="2" y="2"/><use fill="%23081634" href="%23s"/><use fill="%23081634" href="%23s" x="2"/><use fill="%23494b58" href="%23s" x="1" y="1"/></pattern><pattern id="b" width="7" height="11" patternUnits="userSpaceOnUse" patternTransform="scale(20.3) translate(-950.74 -713.05)"><g fill="%23494b58"><use href="%23s"/><use href="%23s" y="5"/><use href="%23s" x="1" y="10"/><use href="%23s" x="2" y="1"/><use href="%23s" x="2" y="4"/><use href="%23s" x="3" y="8"/><use href="%23s" x="4" y="3"/><use href="%23s" x="4" y="7"/><use href="%23s" x="5" y="2"/><use href="%23s" x="5" y="6"/><use href="%23s" x="6" y="9"/></g></pattern><pattern id="h" width="5" height="13" patternUnits="userSpaceOnUse" patternTransform="scale(20.3) translate(-950.74 -713.05)"><g fill="%23494b58"><use href="%23s" y="5"/><use href="%23s" y="8"/><use href="%23s" x="1" y="1"/><use href="%23s" x="1" y="9"/><use href="%23s" x="1" y="12"/><use href="%23s" x="2"/><use href="%23s" x="2" y="4"/><use href="%23s" x="3" y="2"/><use href="%23s" x="3" y="6"/><use href="%23s" x="3" y="11"/><use href="%23s" x="4" y="3"/><use href="%23s" x="4" y="7"/><use href="%23s" x="4" y="10"/></g></pattern><pattern id="c" width="17" height="13" patternUnits="userSpaceOnUse" patternTransform="scale(20.3) translate(-950.74 -713.05)"><g fill="%23081634"><use href="%23s" y="11"/><use href="%23s" x="2" y="9"/><use href="%23s" x="5" y="12"/><use href="%23s" x="9" y="4"/><use href="%23s" x="12" y="1"/><use href="%23s" x="16" y="6"/></g></pattern><pattern id="d" width="19" height="17" patternUnits="userSpaceOnUse" patternTransform="scale(20.3) translate(-950.74 -713.05)"><g fill="%23081634"><use href="%23s" y="9"/><use href="%23s" x="16" y="5"/><use href="%23s" x="14" y="2"/><use href="%23s" x="11" y="11"/><use href="%23s" x="6" y="14"/></g><g fill="%23595b65"><use href="%23s" x="3" y="13"/><use href="%23s" x="9" y="7"/><use href="%23s" x="13" y="10"/><use href="%23s" x="15" y="4"/><use href="%23s" x="18" y="1"/></g></pattern><pattern id="e" width="47" height="53" patternUnits="userSpaceOnUse" patternTransform="scale(20.3) translate(-950.74 -713.05)"><g fill="%23D0021B"><use href="%23s" x="2" y="5"/><use href="%23s" x="16" y="38"/><use href="%23s" x="46" y="42"/><use href="%23s" x="29" y="20"/></g></pattern><pattern id="f" width="59" height="71" patternUnits="userSpaceOnUse" patternTransform="scale(20.3) translate(-950.74 -713.05)"><g fill="%23635BFF"><use href="%23s" x="33" y="13"/><use href="%23s" x="27" y="54"/><use href="%23s" x="55" y="55"/></g></pattern><pattern id="g" width="139" height="97" patternUnits="userSpaceOnUse" patternTransform="scale(20.3) translate(-950.74 -713.05)"><g fill="%2300CD84"><use href="%23s" x="11" y="8"/><use href="%23s" x="51" y="13"/><use href="%23s" x="17" y="73"/><use href="%23s" x="99" y="57"/></g></pattern></defs><rect fill="url(%23a)" width="100%" height="100%"/><rect fill="url(%23b)" width="100%" height="100%"/><rect fill="url(%23h)" width="100%" height="100%"/><rect fill="url(%23c)" width="100%" height="100%"/><rect fill="url(%23d)" width="100%" height="100%"/><rect fill="url(%23e)" width="100%" height="100%"/><rect fill="url(%23f)" width="100%" height="100%"/><rect fill="url(%23g)" width="100%" height="100%"/></svg>')`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "100vh",
        }}
        justifyContent="center"
        alignItems="center"
      >
        <CssBaseline />
        <Item
          elevation={0}
          square={false}
          sx={{
            ...itemsSx,
          }}
        >
          <Grid item lg={12} sx={{
            margin: theme.spacing(0, 2),
          }}>
            <ErrorComponent errors={errors} />
          </Grid>
          <Grid
            item
            sx={{
              ...contentGridSx,
            }}
            gap={0}
          >
            <SetsterLogo src={setsterLogo} alt="Setster Logo" />
            {children}
          </Grid>
        </Item>
      </Grid>
    </ThemeProvider>
  );
};

export default Layout;
